<template>
	<div class="m-container">
		<van-swipe class="m-pageSwiper" ref="pageSwiper" vertical :loop="false" :show-indicators="false" @change="onSwipeChange">
			<van-swipe-item>
				<Home></Home>
			</van-swipe-item>
			<van-swipe-item>
				<Product :subActiveIndex="subActiveIndex"></Product>
			</van-swipe-item>
			<van-swipe-item>
				<Information></Information>
			</van-swipe-item>
			<van-swipe-item>
				<About :subActiveIndex="subActiveIndex" name="about"></About>
			</van-swipe-item>
			<van-swipe-item>
				<About :subActiveIndex="subActiveIndex" name="culture"></About>
			</van-swipe-item>
			<van-swipe-item>
				<Team></Team>
			</van-swipe-item>
			<van-swipe-item>
				<Recruitment></Recruitment>
			</van-swipe-item>
			<van-swipe-item>
				<Contact></Contact>
			</van-swipe-item>
			<van-swipe-item>
				<copyright></copyright>
			</van-swipe-item>
		</van-swipe>
		<Navbar :current="current" @backTop="handleBackTop" v-if="!isHideNav"></Navbar>
		<!-- <BottomMenu :current="current"></BottomMenu> -->
	</div>
</template>

<script>
	export default {
		name: 'm_index',
		components: {
			BottomMenu:() => import('@/components/mobile/BottomMenu.vue'),
			Navbar:() => import('@/components/mobile/Navbar.vue'),
			Home: () => import('./Home.vue'),
			Product: () => import('./Product.vue'),
			Information: () => import('./Information.vue'),
			About: () => import('./About.vue'),
			Team: () => import('./Team.vue'),
			Recruitment: () => import('./Recruitment.vue'),
			Contact: () => import('./Contact.vue'),
			copyright: () => import('./copyright.vue'),
		},
		data() {
			return {
				map:{},
				current: 0,
				subActiveIndex: null,
				isHideNav: false
			}
		},
		watch:{
			$route(to,from){
				var switchTo = this.$route.params.mid ? parseInt(this.$route.params.mid) : 0
				var subswitchTo = this.$route.params.sid ? parseInt(this.$route.params.sid) : 0
				this.subActiveIndex = subswitchTo
				this.changeSwipe(switchTo)
			},
			name(val){
				// console.log(val)
				// this.$refs.proSwipe.swipeTo(this.subActiveIndex)
			}
		},
		methods: {
			onSwipeChange(index) {
				this.current = index;
			},
			handleBackTop() {
				var parent = document.querySelector('.m-pageSwiper');
				var detailBox = parent.querySelectorAll('.detail-box:not([style*="display: none"])')[0];
				// console.log(detailBox)
				if (detailBox) {
					detailBox.scrollTo({
						top: 0,
						behavior: "smooth"
					});	
				} else {
					this.$refs.pageSwiper.swipeTo(0);
				}
			},
			changeSwipe(value) {
				this.$refs.pageSwiper.swipeTo(value);
			},
		},
		mounted() {
			var switchTo = this.$route.params.mid ? parseInt(this.$route.params.mid) : 0
			var subswitchTo = this.$route.params.sid ? parseInt(this.$route.params.sid) : 0
			this.subActiveIndex = subswitchTo
			this.changeSwipe(switchTo);
		}
	}
</script>

<style lang="less">
	@import '@/assets/css/index';
	.van-swipe{
		height: 100%;
	}
	.m-container{
		position: relative;
		// max-width: 750px;
		// margin: 0 auto;
		width: 100%;
		height: 100%;
		background-color: transparent;
	}
</style>